import S, { DataSignal } from 's-js';
import { UserSummary } from 'data/models/UserSummary';
import { BootstrapCache } from 'core/app/bootstrapCache';
import { AuthorizedDataData } from 'data/models/AuthorizedData';
import { LoginRequest } from 'data/models/ChangePasswordRequest';
import { IAjax } from 'lib/Ajax';
import { Entrypoints } from 'core/app/entrypoints';

export type Login = ReturnType<typeof Login>;

export interface LoginParams {
    useLandingPage : boolean;
    onHidePopup : () => void;
}

export function Login(ajax : IAjax, entrypoints : Entrypoints, cache : BootstrapCache, user : DataSignal<UserSummary | null>, { useLandingPage, onHidePopup } : LoginParams) {
    let login = ajax.Url<LoginRequest>(entrypoints.Login),
        dataClient = ajax.Url<AuthorizedDataData>(entrypoints.AuthorizedData),
        loginRequest = new LoginRequest(),
        loginError = S.data(false);

    return {
        LoginRequest: loginRequest,
        LoginError: loginError,
        Login: Login,
        ForgotPassword: ForgotPassword,
        HidePopup: onHidePopup
    };

    function Login() {
        loginError(false);

        let req = login.Post(loginRequest);
        req.then(() =>
            dataClient.Get()
        ).then(json => {
            const
                model = cache.AuthorizedData.update1(req.Date, json),
                userSummary = model.UserSummary()!;

            S.freeze(() => {
                user(userSummary);
                onHidePopup();
            });

            if (useLandingPage) {
                window.location.hash = userSummary.LandingPage() || '';
            } else {
                // The useLandingPage: false option is mainly used by the ajax errors component.
                // Reloading is for the benefit of users who've just gotten the login popup due to an auth error
                // and need to reload the window to retry their failed request.
                // This is a terrible sledge hammer - a much better solution would be to weave retry logic into
                // our ajax layer, such that we only need to retry the failed request and not reload the whole window.
                window.location.reload();
            }
        }).catch(function () {
            loginError(true);
        });
    }

    function ForgotPassword() {
        // close modal
        onHidePopup();
        window.location.hash = 'forgotpassword';
    }
}



// WEBPACK FOOTER //
// ./apps/portcall/login/model.ts